export default __webpack_public_path__ + "static/media/MARCwhite.adf2a552.png";